import { faker } from "@faker-js/faker/locale/ru";
import { useCallback } from "react";
import CreateCharacterMpProvider from "@/core/data-provider/data-mp/create-character/create-character-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { GenderEnum } from "@/domains/createCharacter/constants/general";
import { personalDataSelector, setPersonalData } from "@/domains/createCharacter/slice";

export default function usePersonalData() {
  const dispatch = useAppDispatch();
  const { gender } = useAppSelector(personalDataSelector);

  const onChangeGender = useCallback(
    async (value: GenderEnum) => {
      await CreateCharacterMpProvider.setGender(value);
      await CreateCharacterMpProvider.setDefault();
      dispatch(setPersonalData({ gender: value }));
    },
    [dispatch],
  );

  const randomizeFirstName = useCallback(() => {
    dispatch(
      setPersonalData({
        firstName: (() => {
          let firstName = "";
          while (firstName.length <= 2 || firstName.length > 10) {
            firstName = faker.person.firstName(gender === GenderEnum.Female ? "female" : "male");
          }

          return firstName;
        })(),
      }),
    );
  }, [dispatch, gender]);

  const randomizeLastName = useCallback(() => {
    dispatch(
      setPersonalData({
        lastName: (() => {
          let lastName = "";
          while (lastName.length <= 2 || lastName.length > 10) {
            lastName = faker.person.lastName(gender === GenderEnum.Female ? "female" : "male");
          }

          return lastName;
        })(),
      }),
    );
  }, [dispatch, gender]);

  const randomizeAge = useCallback(() => {
    dispatch(setPersonalData({ age: faker.number.int({ min: 18, max: 99 }) }));
  }, [dispatch]);

  const randomizeAll = useCallback(() => {
    randomizeFirstName();
    randomizeLastName();
    randomizeAge();
  }, [randomizeFirstName, randomizeLastName, randomizeAge]);

  return {
    randomizeFirstName,
    randomizeLastName,
    randomizeAge,
    randomizeAll,
    onChangeGender,
  };
}
